<script lang="ts">
	import { createTabs } from '@melt-ui/svelte'
    import ByName from './lo-search/ByName.svelte'
	import GoogleMapsWrapper from './lo-search/GoogleMapsWrapper.svelte'
	import ByLocation from './lo-search/ByLocation.svelte'
    import type { ComponentProps } from 'svelte'

	export let apiKey: ComponentProps<GoogleMapsWrapper>['apiKey']
	export let rootFolder: string
	export let header: string
	export let searchHeader: string
	export let intro = ''
	export let comboboxNoResultsLabel: ComponentProps<ByName>['comboboxNoResultsLabel'] & ComponentProps<ByLocation>['comboboxNoResultsLabel']
	export let nameTabLabel = 'By Name'
	export let nameFieldLabel: ComponentProps<ByName>['label']
	export let nameFieldPlaceholder: ComponentProps<ByName>['placeholder']
	export let locationTabLabel = 'By Location'
	export let locationFieldLabel: ComponentProps<ByLocation>['label']
	export let locationFieldPlaceholder: ComponentProps<ByLocation>['placeholder']
	export let locationResultsIntro: ComponentProps<ByLocation>['intro']
	export let locationNoLosMessage: ComponentProps<ByLocation>['noLosMessage']
	export let locationNoResultsMessage: ComponentProps<ByLocation>['noResultsMessage']
	export let locationNoResultsLinkText: ComponentProps<ByLocation>['noResultsLinkText']
	export let locationNoResultsLinkHref: ComponentProps<ByLocation>['noResultsLinkHref']
	export let locationNoResultsLinkTarget: ComponentProps<ByLocation>['noResultsLinkTarget']
	export let locationBackToBranchesLabel: ComponentProps<ByLocation>['backToBranchesLabel']
	export let errorMsg: ComponentProps<ByName>['errorMsg'] & ComponentProps<ByLocation>['errorMsg']
	export let mapHeader: ComponentProps<ByLocation>['mapHeader']
	export let branchListHeader: ComponentProps<ByLocation>['branchListHeader']
	export let loListHeader: ComponentProps<ByLocation>['loListHeader']
	export let mapId: ComponentProps<ByLocation>['mapId']
	let locationTerm: string | undefined

	const {
		elements: { root, list, content, trigger },
		states: { value: active }
	} = createTabs({
		defaultValue: 'search-by-name'
	});
</script>

<div class="rich-text max-w-none mb-6">
	<h2>
		{$active === 'search-by-location' && locationTerm
			? `${searchHeader} "${locationTerm}"`
			: header}
	</h2>
	{#if intro.trim()}{@html intro}{/if}
</div>
<div {...$root} use:root class="root">
	<div class="rounded-md flex justify-start items-stretch shadow-[0px_4px_16px_0px_theme(colors.gray.900)1F] w-fit max-w-full mb-6"
		{...$list} use:list
		aria-label="Search for a Loan Advisor"
	>
		{#each [['name', nameTabLabel], ['location', locationTabLabel]] as [id, label]}
			<!-- At time of writing, the id isn't provided for Melt UI -->
			<button
				{...$trigger(`search-by-${id}`)}
				id={`search-by-${id}`}
				use:trigger
				class="btn btn-lg shadow-none btn-light data-[state=active]:btn-twilight rounded-none focus-visible:relative focus-visible:z-10 first:rounded-l-md last:rounded-r-md"
			>{label}</button>
		{/each}
	</div>
	<div {...$content('search-by-name')} use:content>
		<ByName {rootFolder} label={nameFieldLabel} placeholder={nameFieldPlaceholder} {comboboxNoResultsLabel} {errorMsg} />
	</div>
	<div {...$content('search-by-location')} use:content>
		<GoogleMapsWrapper {apiKey} libraries={['places', 'marker']}>
			<ByLocation
				{rootFolder}
				label={locationFieldLabel}
				placeholder={locationFieldPlaceholder}
				intro={locationResultsIntro}
				{comboboxNoResultsLabel}
				bind:term={locationTerm}
				{mapHeader}
				{mapId}
				{errorMsg}
				backToBranchesLabel={locationBackToBranchesLabel}
				{branchListHeader}
				{loListHeader}
				noLosMessage={locationNoLosMessage}
				noResultsMessage={locationNoResultsMessage}
				noResultsLinkText={locationNoResultsLinkText}
				noResultsLinkHref={locationNoResultsLinkHref}
				noResultsLinkTarget={locationNoResultsLinkTarget}
			/>
		</GoogleMapsWrapper>
	</div>
</div>